<template>
  <b-row class="row--gutter-md mb-5" v-if="recipeData.prepTime || recipeData.cookTime || recipeData.servings">
    <b-col class="col--size1">
      <card no-body class="card card-stats">
        <div class="card__content">
          <ul class="list-stats card__list">
            <li v-if="recipeData.prepTime">
              <p>
                <strong>{{ recipeData.prepTime }}</strong>

                Prep Time
              </p>
            </li>
            <li v-if="recipeData.cookTime">
              <p>
                <strong>{{ recipeData.cookTime }}</strong>

                Cook Time
              </p>
            </li>
            <li v-show=" recipeData.calories ">
              <p>
                <strong>{{ recipeData.calories }}</strong>

                Calories
              </p>
            </li>

            <li v-if="recipeData.servings">
              <p>
                <strong v-html="recipeData.servings"></strong>

                Servings
              </p>
            </li>
          </ul><!-- /.list-stats -->
        </div>
      </card>
    </b-col>
  
    <b-col class="col--size2">
      <ul class="list-cards">
        <li class="alt-tag" v-for="tag in dietaryTags" :key="tag.index">
          <slot>
            <img v-if="tag.tag.icon" :src="tag.tag.icon.absoluteUri" />
            <img v-else src="/img/icons/tags/vegetarian.png" />
            <p>{{ tag.tag.name }}</p>
          </slot>
        </li>
      </ul>
    </b-col>
  </b-row>
</template>
<script>

  export default {
    title: 'recipe-stats',
    props: ['recipeData','times'],
    components: {
    },
    data() {
      return {
        data: null,
        altTags: [],
        stats: []
      }
    },
    computed: {
      allTags() {
          return this.$store.state.recipes.current.recipeTags;
      },
      dietaryTags() {
          const tags =[]
          for (const property in this.allTags) {
              if ( this.allTags[property].tag.isDietary ) {
                  tags.push(this.allTags[property]);
              }
          }
          return tags;
      },
    },
    methods: {
      onCreated() {

      },
      totalServings(servings) {
        return servings*this.times
      },
      getAltTags(){
        var altTags = this.recipeData.altTags;
        const tags = [
          {'id': 1, 'name': 'Vegetarian', 'image': 'img/icons/tags/vegetarian.png'},
          {'id': 2, 'name': 'Vegan', 'image': 'img/icons/tags/vegan.png'},
          {'id': 3, 'name': 'Gluten Free', 'image': 'img/icons/tags/gluten-free.png'},
          {'id': 4, 'name': 'Refrigerated', 'image': 'img/icons/tags/refrigerated.png'},
          {'id': 5, 'name': 'K-12 Friendly', 'image': 'img/icons/tags/k12-friendly.png'},
          {'id': 6, 'name': 'No HFCS', 'image': 'img/icons/tags/no-hfcs.png'}
        ]
        
        if(altTags){
          altTags.forEach(tag => {
            var newTag = tags.find(x => x.id === tag)
            this.altTags.push( newTag );
          })
        }
        
      }
    },
    created(){
      this.onCreated();
      this.getAltTags();
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
